import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Match } from '../../../../core/models/match.model'
import { Router } from '@angular/router'

@Component({
  selector: 'match-result',
  templateUrl: './match-result.component.html',
  standalone: true,
  imports: [
    CommonModule,
  ],
  styleUrl: './match-result.component.css'
})
export class MatchResultComponent implements OnInit {
  @Input() match: Match | null = null
  hovering = false
  animate = false
  desactivarHover = false

  constructor(private router: Router) {}

  ngOnInit() {
    this.desactivarHover = this.router.url.includes('/matches/detail')

    this.router.events.subscribe(() => {
      this.desactivarHover = this.router.url.includes('/matches/detail')
    })

    setInterval(() => {
      this.animate = true
      setTimeout(() => this.animate = false, 1500) 
    }, 8000)
  }
}